// Utility function to update CSS variables
export const updateCssVariables = (colors: Record<string, null | string>) => {
  Object.entries(colors).forEach(([key, value]) => {
    if (value) {
      // Convert camelCase to kebab-case for CSS variables
      const cssVarName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
      document.documentElement.style.setProperty(cssVarName, value);
    } else {
      const cssVarName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
      document.documentElement.style.removeProperty(cssVarName);
    }
  });
};
